function resetEconVars() {
        this.econVars = {
            totalOpex: 0.00,
            totalOpexDisplay: 0.00,
            totalCapex: 0.00,
            productRev: 0.00, //daily
            feedCostSum: 0.00, //daily
            productRevAnnual: 0,
            feedCostSumAnnual: 0.00,
            keyFeedStream: 1, //default to stream 1
            keyProductStream: 1,
            interestRate: 0.06, //default to 6%
            years: 20, //default to 20 years
            additionalOpex: 0.00, //default to 0
            additionalCapex: 0.00, //default to 0
            LCOP: 0.00, //default to 0
            npvCalculated: 0.0, //default to 0
            elecCost: 70.00,
            yearsTArray: [],
            discountedCashflowCalculated: [],
            // Labor-related variables
            operatorCount: 5,
            operatorSalary: 50000.00,
            operatorBenefitsBase: 5000.00,
            benefitsPercent: 0.25,
            laborOverheadFactor: 1.5,
            laborCosts: 0.00,
            // Maintenance, tax, and installation variables
            maintenanceCosts: 0.00,          // 3% of adjusted CAPEX
            maintenanceRate: 0.03,          // 3% maintenance rate
            landRentandPropertyTax: 0,
            propertyTaxInsurance: 0.015,    // 1.5% for property tax & insurance
            landRent: 0.015,                // 1.5% for land rent
            environmentalCosts: 0.00,  
            envCharges: 0.01,               // 1% environmental charges
            // Installation/Facility scaling factors
            langFactor: 6,                  // For Liquid Plant from Towler and Sinnot
            materialFactor: 1,              // For carbon steel
            locationFactor: 1.4974,          // Australia
            totalCapexInstalled: 0.00,
            equipmentCapex: 0.00,
            installationCosts: 0.00,
            utilityCosts: 0.00,
            additionalRevenueAnnual: 0.00, //default to 0
            fcopOpexAnnual: 0.00, //default to 0
        }
    }

export default resetEconVars